"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thailandTranslations = void 0;
var _types = require("../../../types");
const thailandTranslations = exports.thailandTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' ขออภัยค่ะ',
  [_types.ErrorPageTranslationKey.buttonText]: 'กลับ',
  [_types.ErrorPageTranslationKey.text]: 'ไม่สามารถใช้งานหน้าเพจได้ชั่วคราวค่ะ',
  [_types.ErrorPageTranslationKey.notFound]: 'ไม่พบหน้าที่กำลังเข้าถึง',
  [_types.ErrorPageTranslationKey.unauthorized]: 'หน้าเว็บที่คุณพยายามเข้าถึงถูกจำกัดและมีคุณสมบัติไม่ตรงตามเกณฑ์ทั้งหมด',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'โปรดติดต่อทีมสนับสนุนออริเฟลมทางอีเมล:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'URL ที่ร้องขอถูกปฏิเสธ!'
};
